import alpha from "color-alpha";
const MuiSwitch = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      padding: "4px",
      margin: "-4px",
      width: "60px",
      height: "40px",
      "&:active": {
        "& .MuiSwitch-switchBase:not(.Mui-disabled), & .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled)": {
          padding: "6px",
          width: "28px",
          height: "28px"
        }
      },
      "& .MuiSwitch-switchBase": {
        transition: "150ms",
        padding: "12px",
        width: "16px",
        height: "16px",
        boxSizing: "content-box",
        color: theme.palette.grey[900],
        "&.Mui-checked": {
          padding: "8px",
          width: "24px",
          height: "24px",
          color: theme.palette.primary[800]
        }
      },
      "& .MuiSwitch-track": {
        transition: "150ms",
        borderRadius: "999px",
        opacity: 1,
        backgroundColor: theme.palette.grey[200],
        border: "2px solid",
        borderColor: theme.palette.grey[600],
        boxSizing: "border-box"
      },
      "& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track": {
        border: "0px solid",
        borderColor: theme.palette.grey[600],
        opacity: 1,
        backgroundColor: theme.palette.primary[800]
      },
      "& .MuiSwitch-switchBase.Mui-disabled+.MuiSwitch-track": {
        border: `2px solid ${alpha(theme.palette.grey[900], 0.12)}`,
        backgroundColor: alpha(theme.palette.grey[300], 0.12),
        opacity: 1
      },
      "& .MuiSwitch-switchBase.Mui-disabled.Mui-checked+.MuiSwitch-track": {
        border: "0px solid",
        backgroundColor: theme.palette.grey[600]
      },
      "& .MuiSwitch-thumb": {
        transition: "150ms",
        backgroundColor: theme.palette.grey[600],
        width: "100%",
        height: "100%",
        boxShadow: "none"
      },
      "& .Mui-checked .MuiSwitch-thumb": {
        backgroundColor: theme.palette.common.white
      },
      "& .Mui-checked:hover .MuiSwitch-thumb": {
        backgroundColor: theme.palette.primary[50]
      },
      "& .Mui-disabled .MuiSwitch-thumb": {
        backgroundColor: theme.palette.grey[600]
      },
      "& .Mui-checked.Mui-disabled .MuiSwitch-thumb": {
        backgroundColor: theme.palette.primary[10]
      },
      "& .MuiSvgIcon-root": {
        transition: "150ms",
        borderRadius: "999px",
        backgroundColor: theme.palette.grey[600],
        boxShadow: `0px 0px 0px 0px ${theme.palette.grey[600]}`,
        color: theme.palette.common.white
      },
      "& .Mui-checked .MuiSvgIcon-root": {
        backgroundColor: theme.palette.common.white,
        boxShadow: `0px 0px 0px 0px ${theme.palette.common.white}`,
        color: theme.palette.primary[900]
      },
      "& .MuiSwitch-switchBase:active .MuiSvgIcon-root": {
        boxShadow: `0px 0px 0px 2px ${theme.palette.grey[600]}`
      },
      "& .MuiSwitch-switchBase:hover.Mui-checked .MuiSvgIcon-root": {
        backgroundColor: theme.palette.primary[75]
      },
      "& .MuiSwitch-switchBase:active.Mui-checked .MuiSvgIcon-root": {
        boxShadow: "0px 0px 0px 2px",
        boxShadowColor: theme.palette.common.white
      },
      "& .MuiSwitch-switchBase:active:hover.Mui-checked .MuiSvgIcon-root": {
        boxShadow: "0px 0px 0px 2px",
        boxShadowColor: theme.palette.primary[75]
      },
      "& .Mui-disabled .MuiSvgIcon-root": {
        backgroundColor: theme.palette.grey[600],
        color: theme.palette.common.white
      },
      "& .Mui-checked.Mui-disabled .MuiSvgIcon-root": {
        backgroundColor: theme.palette.primary[10],
        color: theme.palette.grey[600]
      },
      "&.MuiSwitch-sizeSmall": {
        width: "47px",
        height: "32px",
        "&:active": {
          "& .MuiSwitch-switchBase:not(.Mui-disabled), & .MuiSwitch-switchBase.Mui-checked:not(.Mui-disabled)": {
            padding: "6px",
            width: "20px",
            height: "20px"
          }
        },
        "& .MuiSwitch-switchBase": {
          padding: "10px",
          width: "12px",
          height: "12px",
          "&.Mui-checked": {
            padding: "7px",
            width: "18px",
            height: "18px"
          }
        }
      }
    })
  }
};
export {
  MuiSwitch
};
